import React from "react";
import { useForm } from "react-hook-form";
import { evaluateRiskReviewRules } from "../utils/riskReviewRuleEvaluator";

export const useRiskReviewFormEngine = ({ template, initialValues }) => {
  const form = useForm({ defaultValues: initialValues || {} });
  const values = form.watch();

  React.useEffect(() => {
    form.reset(initialValues || {});
  }, [form, initialValues]);

  const rules = React.useMemo(
    () => evaluateRiskReviewRules({ template, values }),
    [template, values],
  );

  return { ...form, values, rules };
};
